module.exports = __webpack_public_path__ + "images/wxwork/ic-wcwf-3@2x-cb2126934a402bf6049d64aa5419dfcb.png";